import React, { useState, useMemo } from 'react';
import CONFIGURACIONES from '../../../util/constants';

// Componente principal
const SelectorDays = ({ selectedDays, setSelectedDays }) => {
  // Estado para el manejo del despliegue del selector en móvil (usando la clase 'collapse')
  const [isOpen, setIsOpen] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

  // Lógica para añadir un día
  const addDay = (day) => {
    // Solo añade si no está ya seleccionado
    if (!selectedDays.includes(day)) {
      // Usamos el ALL_DAYS para ordenar la nueva lista inmediatamente
      const newSelectedDays = [...selectedDays, day].sort(
        (a, b) => CONFIGURACIONES.INIT.ALL_DAYS.indexOf(a) - CONFIGURACIONES.INIT.ALL_DAYS.indexOf(b)
      );
      setSelectedDays(newSelectedDays);
    }
    // setIsOpen(CONFIGURACIONES.INIT.STATUS_FALSE); // Cierra el selector después de seleccionar un día
  };

  // Lógica para quitar un día
  const removeDay = (dayToRemove) => {
    setSelectedDays(selectedDays.filter(day => day !== dayToRemove));
  };

  // Memoria computada para saber qué días están disponibles para ser añadidos
  const availableDays = useMemo(() => {
    return CONFIGURACIONES.INIT.ALL_DAYS.filter(day => !selectedDays.includes(day));
  }, [selectedDays]);

  return (
    // Contenedor principal centrado
    <>
      {/* 1. Días Seleccionados (Badges/Chips) */}
      <section className="mb-4">
        <h2 className="h5 font-weight-bold text-secondary mb-3">Días Seleccionados ({selectedDays.length})</h2>
        <div className="d-flex flex-wrap align-content-start p-3 bg-light border rounded justify-content-start" style={{ minHeight: '50px', borderColor: '#cfe2f3' }}>
                  {selectedDays.length === 0 ? (
                    <p className="text-muted font-italic m-0">No hay días seleccionados. Usa el selector para añadir.</p>
                  ) : (
                    selectedDays.map(day => (
                      // Badge/Tag del día seleccionado
                      <span 
                        key={day}
                        // Ajustado: Clase badge-info y texto más pequeño
                        className="badge badge-pill badge-success py-1 px-3 mr-2 mb-2 d-flex align-items-center"
                        style={{ fontSize: '0.85rem' }}
                      >
                        <span className="mr-2">{day}</span>
                        
                        {/* Botón de Quitar */}
                        <button type="button"
                          onClick={() => removeDay(day)}
                          aria-label={`Quitar ${day}`}
                          // Ajustado: Clase "close" para centrar y reducir fuente
                          className="close ml-1 text-white"
                          style={{ fontSize: '1rem', opacity: '0.9', marginTop: '-2px' }}
                        >
                          &times;
                        </button>
                      </span>
                    ))
                  )}
                </div>
      </section>

      {/* 2. Selector para Añadir Días */}
      <section>
        <h2 className="h5 font-weight-bold text-secondary mb-3">Añadir Días</h2>

        {availableDays.length === 0 ? (
          <div className="alert alert-success text-center border-success" role="alert">
            <p className="font-weight-bold m-0">¡Todos los días de la semana han sido seleccionados! 🎉</p>
          </div>
        ) : (
          // Contenedor del selector para manejo responsivo
          <div className="position-relative">

            {/* Vista para Desktop y Tablet (Grid de botones) */}
            <div className="row mx-n1 d-none d-sm-flex"> 
              {availableDays.map(day => (
                // Cada botón está envuelto en una columna responsiva
                <div key={`col-add-btn-${day}`} className="col-12 col-md-4 col-lg-3 px-1 mb-2">
                  <button
                    onClick={() => addDay(day)}
                    className="btn btn-sm btn-info shadow w-100" // w-100 para que ocupe todo el ancho de la columna
                  >
                    + {day}
                  </button>
                </div>
              ))}
            </div>

            {/* Vista para Móvil (Botón de Despliegue) */}
            <div className="d-sm-none">
              <button type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="btn btn-info btn-sm w-100 shadow d-flex justify-content-between align-items-center"
                aria-expanded={isOpen}
                aria-controls="mobileDaysMenu"
              >
                {isOpen ? 'Ocultar Días Disponibles' : `Añadir Día (${availableDays.length} disponibles)`}
                <span className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`}></span>
                {/* Nota: Asumiendo Font Awesome o un icono similar está disponible en BS4 */}
              </button>

              {/* Menú Desplegable Móvil (Collapse) */}
              <div className={`collapse ${isOpen ? 'show' : ''} mt-2`} id="mobileDaysMenu">
                <div className="list-group shadow-sm">
                  {availableDays.map(day => (
                    <button type="button"
                      key={`mobile-add-btn-${day}`}
                      onClick={() => addDay(day)}
                      className="list-group-item list-group-item-action btn btn-sm"
                    >
                      + {day}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default SelectorDays;